import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "_social-ft",
  "use": "_social-ft-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"_social-ft\">\n<rect width=\"32\" height=\"32\" fill=\"white\" />\n<path d=\"M6.43066 22.3996V9.59961H14.6307V11.5434H8.74941V15.0184H14.0682V16.9621H8.74941V22.3996H6.43066Z\" fill=\"#6C71D3\" />\n<path d=\"M16.1807 11.5434V9.59961H26.3932V11.5434H22.4369V22.3996H20.1369V11.5434H16.1807Z\" fill=\"#282C32\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol